import { Card, CardBody, Col } from 'reactstrap'
import { ColoredBreadcrumbs } from '../../../../Utils/Constants'
import { coloredBreadcrumbData } from '../../../../Data/BonusUi/Breadcrumb'
import StaticColoredBreadcrumb from './StaticColoredBreadcrumb'
import DynamicColoredBreadcrumb from './DynamicColoredBreadcrumb'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const ColoredBreadcrumb = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeaderCommon title={ColoredBreadcrumbs} span={coloredBreadcrumbData} />
        <CardBody>
          <StaticColoredBreadcrumb />
          <DynamicColoredBreadcrumb />
        </CardBody>
      </Card>
    </Col>
  )
}

export default ColoredBreadcrumb